import React, { Suspense, useCallback, useState } from "react";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "../ErrorBoundary";
import { LoadingSpinner } from "../ui/LoadingSpinner";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

export const DashboardLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleMenuClick = useCallback(() => {
    setSidebarOpen(true);
  }, []);

  const handleSidebarClose = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar isOpen={sidebarOpen} onClose={handleSidebarClose} />

      <div className="lg:pl-64">
        <Header onMenuClick={handleMenuClick} />

        <main className="min-h-0">
          <div className="px-3 sm:px-4 lg:px-6 xl:px-8 py-4 sm:py-6">
            <div className="max-w-full overflow-hidden">
              <ErrorBoundary>
                <Suspense
                  fallback={
                    <div className="flex justify-center items-center h-64">
                      <LoadingSpinner size="lg" />
                    </div>
                  }
                >
                  <Outlet />
                </Suspense>
              </ErrorBoundary>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
